import { render } from "./CountryRanking.vue?vue&type=template&id=3491b22c&scoped=true"
import script from "./CountryRanking.vue?vue&type=script&lang=js"
export * from "./CountryRanking.vue?vue&type=script&lang=js"

import "./CountryRanking.vue?vue&type=style&index=0&id=3491b22c&scoped=true&lang=scss"

import exportComponent from "/builds/vei/portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3491b22c"]])

export default __exports__